
import { Component, Vue } from "vue-property-decorator";
import ActivityModel from "@/app/models/activity/activity.model";
import store from "@/store";
import router, { Routes } from "@/router";
import Loader from "@/components/common/Loader.vue";
import { authenticationService } from "@/services/authentication.service";

@Component({
  components: { Loader },
})
export default class ActiveActivitySwitcher extends Vue {
  loading = false;

  get activeActivityName(): string {
    if(!this.$store.state.activity.currentActivity) return this.$tc('general.noactiveactivity');

    const activity = this.$store.state.activity.currentActivity;
    if(!activity) return '...';
    let name = activity.translationKey && activity.translationKey !== ''? this.$tc(activity.translationKey) : activity.name.toUpperCase();
    if(activity.translationKey && activity.translationKey === name){
      name = activity.name.toUpperCase();
    }
    return name;
  }

  get eligibleActivities(): ActivityModel[] {
    return this.$store.state.activity.eligibleActivities;
  }

  public getNameForActivity(activity: ActivityModel){
    if(!activity) return '...';
    let name = activity.translationKey && activity.translationKey !== ''? this.$tc(activity.translationKey) : activity.name.toUpperCase();
    if(activity.translationKey && activity.translationKey === name){
      name = activity.name.toUpperCase();
    }
    return name;
  }

  changeActiveActivity(selectedActivity: ActivityModel): void {

    const overviewKeys = Object.keys(sessionStorage).filter(value => value && value.startsWith('overview_'));
    overviewKeys.forEach(value => {
      sessionStorage.removeItem(value);
    });

    store.dispatch("setCurrentActivity", selectedActivity);
    setTimeout(async ()=>{
      await router.push('/');
      location.reload();
    },100);
  }

}
